import { m } from 'framer-motion';
// import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
// import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

import { useCollapseNav } from '../../components/chat/hooks/use-collapse-nav';
// import { Scrollbar } from '../../components/scrollbar';
import { ChatLayout } from '../../components/chat/layout';
import { ChatNav } from '../../components/chat/chat-nav';
import { ChatMessageList } from '../../components/chat/chat-message-list';
import EmptyContent from '../../components/EmptyContent';
import { ChatMessageInput } from '../../components/chat/chat-message-input';
import { varTap, varHover, transitionTap } from '../../components/animate';
import { useBoolean } from '../../hooks/useBoolean';
// import { bgBlur } from '../../utils/cssStyles';
import Iconify from '../../components/Iconify';
import { useDispatch, useSelector } from '../../redux/store';
import useAuth from '../../hooks/useAuth';
import { getConversations, setSelectedId } from '../../redux/slices/aiConversation';

// ----------------------------------------------------------------------

export default function ShahidiAssistant() {
  const { ability } = useAuth();
  const dispatch = useDispatch();
  const { isLoading, list, selectedId, draftMessage } = useSelector((state) => state.aiConversation);

  // const theme = useTheme();
  const { value: open, onFalse: onClose, onTrue: onOpen } = useBoolean();

  const conversationsNav = useCollapseNav();

  const openAssistant = async () => {
    try {
      await dispatch(getConversations());
      onOpen();
    } catch (error) {
      console.log({ status: 401, message: error.message, code: 'error' });
    }
  };

  const handleNewConversation = () => {
    dispatch(setSelectedId(null));
  };

  const selectedConversation = list.find((cnv) => String(cnv.id) === String(selectedId));
  const currentMessages = selectedConversation?.messages ?? (draftMessage ? { "Aujourd'hui": [draftMessage] } : {});
  const hasMessages =
    currentMessages &&
    (Array.isArray(currentMessages) ? currentMessages.length > 0 : Object.keys(currentMessages).length > 0);

  const renderHead = () => (
    <Box
      sx={{
        py: 2,
        pr: 1,
        pl: 2.5,
        minHeight: 68,
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <Typography variant="h6" sx={{ flexGrow: 1 }}>
        Assistant Shahidi
      </Typography>

      <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}>
        <IconButton onClick={handleNewConversation} title="Nouvelle conversation">
          <Iconify width={24} icon="ri:chat-new-line" />
        </IconButton>
      </Box>
    </Box>
  );

  // const renderList = () => (
  //   <Scrollbar>
  //     <Box component="ul">
  //       {notifications?.map((notification) => (
  //         <Box component="li" key={notification.id} sx={{ display: 'flex' }}>
  //           conversations
  //         </Box>
  //       ))}
  //     </Box>
  //   </Scrollbar>
  // );

  return (
    ability.can('index', 'Conversation') &&
    ability.can('create', 'Conversation') && (
      <>
        <IconButton
          component={m.button}
          whileTap={varTap(0.96)}
          whileHover={varHover(1.04)}
          transition={transitionTap()}
          aria-label="Shahidi AI Assistant"
          onClick={openAssistant}
        >
          <AutoAwesomeIcon />
        </IconButton>

        <Drawer
          open={open}
          onClose={onClose}
          anchor="right"
          hideBackdrop={false}
          PaperProps={{
            sx: {
              width: 1,
              maxWidth: 650
              // ...{
              //   ...bgBlur({ color: theme.palette.background.default })
              // }
            }
          }}
        >
          {renderHead()}
          <ChatLayout
            slots={{
              nav: (
                <ChatNav
                  conversations={list}
                  selectedId={selectedId}
                  collapseNav={conversationsNav}
                  loading={isLoading}
                />
              ),
              main: (
                <>
                  {hasMessages || isLoading ? (
                    <ChatMessageList conversationId={selectedId} messages={currentMessages} loading={isLoading} />
                  ) : (
                    <EmptyContent
                      title="Assistant Shahidi"
                      description="Posez une question pour démarrer une conversation..."
                    />
                  )}

                  <ChatMessageInput />
                </>
              )
            }}
          />
        </Drawer>
      </>
    )
  );
}
